import React__default, { createElement, useRef, useEffect } from 'react';
import { Button as Button$1, Input as Input$1, Checkbox as Checkbox$1, DrawerCloseButton as DrawerCloseButton$1, ChakraProvider, Box, Center, Flex, Heading, forwardRef, VStack, Image, Spacer, Spinner, Text } from '@chakra-ui/react';
export * from '@chakra-ui/react';
export { Button as CharkraButton } from '@chakra-ui/react';
import { motion, isValidMotionProp } from 'framer-motion';

var Button = React__default.forwardRef(function (props, ref) {
  return React__default.createElement(Button$1, Object.assign({
    ref: ref,
    background: 'blue.800',
    textTransform: 'uppercase',
    size: 'lg',
    fontSize: '14px',
    borderRadius: '4px'
  }, props), props.children);
});

var Input = function Input(props) {
  return React__default.createElement(Input$1, Object.assign({
    size: 'lg',
    borderRadius: '4px',
    bgColor: 'white',
    focusBorderColor: 'blue.500',
    _invalid: {
      backgroundColor: 'red.50',
      borderColor: 'red.400',
      borderWidth: '2px',
      borderStyle: 'solid'
    }
  }, props), props.children);
};

var Checkbox = function Checkbox(props) {
  return React__default.createElement(Checkbox$1, Object.assign({
    size: 'md',
    borderColor: 'grey.900',
    color: 'grey.400',
    spacing: 4
  }, props), props.children);
};

var DrawerCloseButton = function DrawerCloseButton(props) {
  return React__default.createElement(DrawerCloseButton$1, Object.assign({
    fontSize: '20px',
    position: 'relative',
    top: '0',
    right: '0'
  }, props));
};

var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
      theme = _ref.theme;
  return createElement(ChakraProvider, {
    theme: theme
  }, children);
};

var Header = function Header(_ref) {
  var children = _ref.children,
      startComponent = _ref.startComponent,
      endComponent = _ref.endComponent;
  var StartComponent = startComponent ? React__default.createElement(Box, null, React__default.createElement(Center, {
    h: '100%'
  }, startComponent)) : null;
  var EndComponent = endComponent ? React__default.createElement(Box, null, React__default.createElement(Center, {
    h: '100%'
  }, endComponent)) : null;
  var marginRight = startComponent ? 5 : 0;
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Flex, {
    bg: 'blue.800',
    maxWidth: '2xl',
    w: '100%',
    marginX: 'auto',
    zIndex: 200,
    position: 'fixed',
    color: 'white',
    px: '6',
    height: '14',
    justifyContent: 'start'
  }, StartComponent, React__default.createElement(Box, {
    w: '100%'
  }, React__default.createElement(Center, {
    h: '100%',
    px: 2,
    mr: marginRight
  }, React__default.createElement(Heading, {
    fontSize: {
      base: 'md',
      md: 'lg'
    },
    isTruncated: true,
    letterSpacing: -0.5,
    lineHeight: '1'
  }, children))), EndComponent), React__default.createElement(Box, {
    height: '14'
  }));
};

var MotionBox = motion.custom(forwardRef(function (props, ref) {
  var chakraProps = Object.fromEntries(Object.entries(props).filter(function (_ref) {
    var key = _ref[0];
    return !isValidMotionProp(key);
  }));
  return React__default.createElement(Box, Object.assign({
    ref: ref
  }, chakraProps));
}));

var LoadingSpinner = function LoadingSpinner(_ref) {
  var image = _ref.image;
  return React__default.createElement(Center, {
    flex: 1
  }, React__default.createElement(VStack, null, React__default.createElement(MotionBox, {
    initial: {
      scale: 0.4
    },
    animate: {
      scale: 1
    },
    transition: {
      duration: 1
    }
  }, React__default.createElement(Image, {
    src: image,
    alt: 'My Lifetime logo',
    h: '36px'
  })), React__default.createElement(Spacer, {
    height: 3
  }), React__default.createElement(Spinner, {
    color: 'blue.800'
  })));
};

var MonoText = function MonoText(props) {
  return React__default.createElement(Text, Object.assign({
    fontFamily: 'mono'
  }, props), props.children);
};

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var HEADER_HEIGHT = 170;

var ParallaxHeader = function ParallaxHeader(_ref) {
  var headerBackground = _ref.headerBackground,
      header = _ref.header,
      children = _ref.children,
      backgroundProps = _ref.backgroundProps,
      props = _objectWithoutPropertiesLoose(_ref, ["headerBackground", "header", "children", "backgroundProps"]);

  return React__default.createElement(Box, {
    display: 'flex',
    position: 'relative',
    flex: 1,
    alignItems: 'stretch'
  }, React__default.createElement(VStack, {
    width: '100%',
    height: HEADER_HEIGHT + 11,
    position: 'fixed',
    marginX: 'auto',
    maxWidth: '2xl',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    paddingBottom: '11px',
    textShadow: '0px 0px 16px black',
    overflow: 'hidden'
  }, React__default.createElement(HeaderBg, Object.assign({
    image: headerBackground
  }, backgroundProps)), header), React__default.createElement(Flex, Object.assign({
    flex: 1,
    flexDirection: 'column',
    alignItems: 'stretch',
    background: 'white',
    borderTopLeftRadius: 11,
    borderTopRightRadius: 11,
    marginTop: HEADER_HEIGHT,
    p: '6',
    zIndex: 1
  }, props), children));
};

var HeaderBg = function HeaderBg(_ref2) {
  var image = _ref2.image,
      props = _objectWithoutPropertiesLoose(_ref2, ["image"]);

  var boxRef = useRef(null);
  useEffect(function () {
    var func = function func() {
      if (!boxRef.current) return;
      var y = window.scrollY / 5;
      var scale = 1 + window.scrollY / 200;
      var tx = "translate3d(-50%, -" + y + "%, 0) scale(" + scale + ")";
      boxRef.current.style.transform = tx;
    };

    document.addEventListener('scroll', func);
    return function () {
      return document.removeEventListener('scroll', func);
    };
  }, []);
  return React__default.createElement(Box, Object.assign({
    ref: boxRef,
    position: 'absolute',
    zIndex: '-1',
    top: '0',
    left: '50%',
    width: '100%',
    height: HEADER_HEIGHT + 11,
    transform: 'translateX(-50%)',
    backgroundPosition: 'center 20%',
    backgroundSize: 'cover',
    backgroundImage: "linear-gradient(to right, #0002, #0002), linear-gradient(to right, #00466faa, #00466faa), url('" + image + "')",
    backgroundBlendMode: 'normal, soft-light, normal'
  }, props));
};

export { Button, Checkbox, DrawerCloseButton, Header, Input, LoadingSpinner, MonoText, MotionBox, ParallaxHeader, ThemeProvider };
//# sourceMappingURL=index.modern.js.map
